// src/components/FacebookPost.js

import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowRight } from 'lucide-react';
import '../styles/FacebookPost.scss';

export default function FacebookPagePosts() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { t } = useTranslation();

  const username = "ptvn_goraul";
  const postLimit = 10;

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        setLoading(true);
        const apiUrl = 'https://vhserver.desync.in/public/api/facebook/posts';

        const response = await fetch(apiUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ username, limit: postLimit })
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(`Failed to fetch posts: ${response.status} ${response.statusText}`);
        }

        if (data.success && Array.isArray(data.posts)) {
          setPosts(data.posts);
        } else {
          setPosts([]);
        }

        setLoading(false);
      } catch (err) {
        setError(err.message || 'Unknown error occurred');
        setLoading(false);
      }
    };

    fetchPosts();
  }, []);

  const formatDate = (dateString) => {
    try {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    } catch {
      return dateString;
    }
  };

  return (
    <div className="facebook-posts">
      <div className="facebook-posts__header">
        <span className="section-tag">Campus Buzz</span>
        <h2 className="facebook-posts__heading">{t('latest_happenings')}</h2>
        <p className="facebook-posts__sub">Live updates, student celebrations, and community news from our official page</p>
      </div>

      {loading ? (
        <div className="facebook-posts__loading">
          <div className="facebook-posts__spinner"></div>
          <p>{t('loading')}</p>
        </div>
      ) : error ? (
        <div className="facebook-posts__error">
          <p>{t('error_loading_posts')}</p>
        </div>
      ) : posts.length === 0 ? (
        <p className="facebook-posts__empty">{t('no_posts')}</p>
      ) : (
        <div className="facebook-posts__scroll-container">
          <div className="facebook-posts__scroll-track">
            {posts.map(post => (
              <div key={`first-${post.id}`} className="facebook-posts__card">
                {post.image && (
                  <div className="facebook-posts__image-container">
                    <img 
                      src={post.image} 
                      alt="Post content" 
                      className="facebook-posts__image"
                      loading="lazy" 
                    />
                  </div>
                )}
                
                <div className="facebook-posts__content">
                  <div className="facebook-posts__date">
                    {formatDate(post.createdAt)}
                  </div>
                  
                  {post.message && (
                    <div className="facebook-posts__message">
                      <p>{post.message}</p>
                    </div>
                  )}
                  
                  <div className="facebook-posts__link-container">
                    <a 
                      href={post.url} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="facebook-posts__link"
                    >
                      <span>{t('read_more')}</span>
                      <ArrowRight size={14} />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
